import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { TagComponent } from '@pedix-workspace/angular-ui-alert';
import { IconBackComponent } from '@pedix-workspace/angular-ui-icons';
import { CurrencyFormatPipe } from '@pedix-workspace/pedixapp-shared-pipes';
import { UpsellHint, formatFeminineOrdinal } from '@pedix-workspace/shared-promotions';

@Component({
  selector: 'pxw-upsell-hint',
  templateUrl: './upsell-hint.component.html',
  styleUrls: ['./upsell-hint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, TagComponent, IconBackComponent],
  providers: [CurrencyFormatPipe],
})
export class UpsellHintComponent {
  private currencyFormat = inject(CurrencyFormatPipe);
  readonly hint = input.required<UpsellHint>();

  protected readonly templateKey = computed(() => {
    const family = this.hint().winningFamily === 'nthUnit' ? 'generic' : this.hint().winningFamily;
    return `promotions.upsellHint.${family}`;
  });

  protected readonly templateParams = computed<Record<string, unknown>>(() => {
    const hint = this.hint();
    return {
      neededQuantity: hint.neededQuantity,
      savingsAmount: this.currencyFormat.transform(hint.totalSavingsAmount),
      buy: hint.buyXPayYConfig?.buy,
      pay: hint.buyXPayYConfig?.pay,
      percentage: hint.progressivePercentage ?? hint.nthUnitConfig?.discountPercentage,
      // n-ésima: `ordinal` (es → "2da") and `n` (en → "#2"), matching the promo-tag convention.
      n: hint.nthUnitConfig?.nthUnit,
      ordinal: hint.nthUnitConfig ? formatFeminineOrdinal(hint.nthUnitConfig.nthUnit) : undefined,
    };
  });
}
